import { useTranslation } from "hhn-commons";
import { ChatListPanelHeader } from "./ChatListPanelHeader";

export const GroupChatListPanelHeader = ({
  unreadChatCount,
  searchResultCount,
  listSize,
}: {
  unreadChatCount?: number;
  searchResultCount?: number;
  listSize?: number;
}) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "chat" });

  let showPanelHeader = false;
  let unreadChatCountText = "";
  let searchResultsText = "";
  let separator = "";
  if (listSize === 0) {
    showPanelHeader = true;
    unreadChatCountText = `0 ${tNs("header.results")}`;
  } else {
    const hasUnreadChats =
      unreadChatCount !== undefined && unreadChatCount >= 0;
    const hasSearchResults =
      searchResultCount !== undefined && searchResultCount > 0;

    showPanelHeader = hasUnreadChats || hasSearchResults;

    if (hasSearchResults) {
      searchResultsText = `${searchResultCount} ${tNs("header.results")}`;
    }

    if (hasUnreadChats) {
      unreadChatCountText = `${unreadChatCount} ${tNs("header.unreadLabel")}`;
    }

    if (hasSearchResults && hasUnreadChats) {
      separator = ", ";
    }
  }

  const renderHeaderContent = () => {
    return (
      showPanelHeader && (
        <>
          {searchResultsText}
          {separator}
          {unreadChatCountText}
        </>
      )
    );
  };
  return <ChatListPanelHeader header={renderHeaderContent()} />;
};
